import {createFileRoute, Navigate} from '@tanstack/react-router';

export const Route = createFileRoute('/_app/volleyball/')({
    component: RouteComponent,
})

function RouteComponent() {
    return <Navigate to="/volleyball/leagues/" />;
}
